import React from 'react'
import { func, oneOfType, number, string } from 'prop-types'
import { PromocaoProvider } from '../../contexts/PromocaoContext'
import CupomPromocaoInput from './CupomPromocaoInput'
import InformacaoPromocao from './InformacaoPromocao'

const CupomPromocao = ( { formaPagamento, freteEntrega, idAssinatura, idPlano, onConfirmar, promocaoExterna, tipoAssinatura, setValorDesconto, valorPlanoConclusao, email } ) => {
  return (
    <PromocaoProvider>
      <CupomPromocaoInput
        email={ email }
        formaPagamento={ formaPagamento }
        idAssinatura={ idAssinatura }
        idPlano={ idPlano }
        onConfirmar={ onConfirmar }
        promocaoExterna={ promocaoExterna }
        tipoAssinatura={ tipoAssinatura }
      />

      <InformacaoPromocao
        freteEntrega={ freteEntrega }
        setValorDesconto={ setValorDesconto }
        valorPlanoConclusao={ valorPlanoConclusao }
      />
    </PromocaoProvider>
  )
}

CupomPromocao.defaultProps = {
  'onConfirmar': null,
  'promocaoExterna': null,
  'setValorDesconto': () => {}
}

CupomPromocao.propTypes = {
  'email': string.isRequired,
  'formaPagamento': string.isRequired,
  'freteEntrega': number.isRequired,
  'idAssinatura': oneOfType( [ number, string ] ).isRequired,
  'idPlano': oneOfType( [ number, string ] ).isRequired,
  'onConfirmar': func,
  'promocaoExterna': string,
  'setValorDesconto': func,
  'tipoAssinatura': string.isRequired,
  'valorPlanoConclusao': number.isRequired
}

export default CupomPromocao
